import { schemes, zSchema } from "@zeal/common";
import { partnerBusinessDocumentItemSchema } from "../listPartnerBusinessDocuments/listPartnerBusinessDocuments.schema";

export const getCompanyUBODocumentParamsSchema = zSchema.object({
  companyID: schemes.uuid(),
  first_name: zSchema.string(),
  last_name: zSchema.string(),
});

export type TGetCompanyUBODocumentParams = zSchema.infer<
  typeof getCompanyUBODocumentParamsSchema
>;

export const getCompanyUBODocumentResponseSchema = zSchema.object({
  ubo_document: partnerBusinessDocumentItemSchema.optional(),
});

export type TGetCompanyUBODocumentResponse = zSchema.infer<
  typeof getCompanyUBODocumentResponseSchema
>;
